import { handleDownloadUrlResponse } from "@newLibs/converting";
import { MvnMessage } from "@newLibs/utils";
import { notify } from "@newHooks/context/snackbar/notify";
import { useBaseMutation } from "../baseMutation";
import { COMMON_LANG } from "@maven-msg/lang/common";
import { DownloadDocumentSignMergeBySignerTokenRequest, DownloadDocumentSignMergeResponse } from "@maven-rest/docs/DocumentMerge.dto";
import { DocumentSignMergeUrl } from "@maven-rest/docs/DocumentSignMerge.url";

export function useDownloadDocumentWithCertificateBySignerTokenMutation(req: {
  pathVariable: Pick<DownloadDocumentSignMergeBySignerTokenRequest, "signerToken" | "fileExportHistoryId">;
}) {
  const { signerToken, fileExportHistoryId } = req.pathVariable;

  return useBaseMutation<DownloadDocumentSignMergeResponse, DownloadDocumentSignMergeBySignerTokenRequest>({
    fnOption: {
      url: DocumentSignMergeUrl.downloadDocumentSignWithCertificateBySignerToken(fileExportHistoryId, signerToken),
    },
    onSuccess: (data) => handleDownloadUrlResponse(data.url),
    onError: (error) => notify(MvnMessage(COMMON_LANG.ERROR, { message: error.responseMessage }), "WARN"),
  });
}
